<template>
    <b-container fluid="xl" class="mt-0 p-0">
        <b-row>
            <b-col>
                <Headerlayout :headertext="$t('crm.campaign.tabletitle')"
                    :contenttext="$t('crm.campaign.tablecontent')">
                </Headerlayout>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                    <MasterEmpty v-if="items.length === 0" eheader="Campaign Table" econtent="Campaign Table"
                        eimg="/src/assets/Img/Icons/boxmaster.svg" @createNew="IsAdd" />
                    <Tableview v-if="items.length > 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                        :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                        :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                        selectionMode="single" dataKey="ID" @row-click="RowClick">
                        <template v-slot:Add>
                            <span class="add">
                                <AddButton @click="IsAdd" :btnname="$t('btn.newcampaign')" class="float-rights my-3"
                                    iconClass="pi pi-plus"></AddButton>
                            </span>
                        </template>
                        <template v-slot:status="{ data }">
                            <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                            <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                        </template>
                        <template v-slot:action="{ data }">
                            <span>
                                <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                    @click="toggle($event, data)" />
                            </span>
                        </template>
                    </Tableview>
                </div>
            </b-col>
        </b-row>
        <Dialog v-model:visible="campaigntype" modal header="Campaign Type" :style="{ width: '50rem' }"
            :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <b-row>
                <b-col lg="6" md="6">
                    <div class="text-center">
                        <img class="py-3" src="../../../../assets/Img/icons/onetimecampaignimg.png" />
                        <p class="common-heading1">One Time Campaign</p>
                        <p class="campaignpopupcontent">
                            Brief notification to patients about an upcoming appointment or important healthcare update,
                            sent
                            only once for immediate information dissemination.
                        </p>
                        <AddButton btnname="Choose" @click="IsAddCampaign(1)" />
                    </div>
                </b-col>
                <b-col lg="6" md="6">
                    <div class="text-center">
                        <img class="py-3" src="../../../../assets/Img/icons/multitimecampaignimg.png" />
                        <p class="common-heading1">Reoccurring Campaign</p>
                        <p class="campaignpopupcontent">
                            Regular and ongoing communication with patients for updates, reminders, and continuous
                            engagement,
                            ensuring consistent and timely information exchange between healthcare providers and
                            patients. </p>
                        <AddButton btnname="Choose" @click="IsAddCampaign(2)" />
                    </div>
                </b-col>
            </b-row>
        </Dialog>
    </b-container>
    <Toast />

    <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
    <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
    <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
    <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
        :content="$t('confirmation.editcontent')" />
    <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="contentdel" @yes="IsDelete(dataEdit)"
        @no="Deletemodel = false" />
    <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />

</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import Tableview from "../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import { checkPermission } from "../../service/AccessControl";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import { useToast } from "primevue/usetoast";
import campaignService from '../../service/campaignService';
import { onMounted } from 'vue';
import moment from "moment";
import SkeletonTableLoader from "../../../../components/FormComponents/SkeletonTableLoader.vue";
import MasterEmpty from "../../../../components/Masters/MasterEmpty.vue";
import InActivatedSuccessfully from "../../../../components/FormComponents/InActivateSuccessfully.vue";
import ActivatedSuccessfully from "../../../../components/FormComponents/ActivateSuccessfully.vue";
import EditConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../components/FormComponents/DeletedSuccessfully.vue";
import { useI18n } from 'vue-i18n';
import MastersService from "../../service/MastersService";

export default defineComponent({
    components: {
        Tableview,
        Headerlayout,
        SkeletonTableLoader,
        MasterEmpty,
        DeletedSuccessfully,
        DeleteConfirmationVue,
        EditConfirmation,
        InActivatedSuccessfully,
        ActivatedSuccessfully,
    },

    setup() {
        onMounted(() => {
            IsShow()
            FunctionRights()
        })
        //Declaration

        //get local storage session data
        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }

        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }

        let SessionEntityData = localStorage.getItem("EntityData");
        let EntityData;
        if (SessionEntityData !== null) {
            EntityData = JSON.parse(SessionEntityData);
        }
        //

        const router = useRouter();
        const route = useRoute();
        const toast = useToast();
        const { t } = useI18n();
        const items = ref([]);
        const loading = ref(false)
        const loading1 = ref(false)
        let campaigntype = ref(false)
        let Rights: any = ref({
            Create: false,
            Update: false,
            Read: false,
            Delete: false,
        });
        let ObjOperationId = ref({
            CreateId: 0,
            UpdateId: 0,
            ReadId: 0,
            DeleteId: 0,
        });
        const contentdel = ref("");
        let InActivevisible = ref(false);
        let Activevisible = ref(false);
        const datas = ref();
        const menu = ref();
        const dataEdit = ref();
        const pop = ref({
            activatepop: false,
            inactivepop: false,
        });
        const deletepop = ref(false);
        const Deletemodel = ref(false);
        const Editmodel = ref(false);
        const editItems = ref();

        //DataTable Fields
        const headers = [
            {
                header: "S.No",
                field: "RowNumber",
                class: 'filterdisplaynone'
            },
            {
                header: "Created on",
                field: "CampaignDate",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: "Campaign Name",
                field: "CampaignName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'boldclass',
            },
            {
                header: 'Campaign Owner',
                field: 'UserName',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            {
                header: 'Recipients',
                field: 'TotalRecipients',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
                bodyclass: "bluecolor width150",
            },
            // {
            //     header: 'Channels',
            //     field: 'countlanguage',
            //     filterTemplate: 'MultiSelect',
            //     ShowMactchMode: false,
            //     class: 'width150'
            // },
            // {
            //     header: 'Start date',
            //     field: 'countMC',
            //     filterTemplate: 'MultiSelect',
            //     ShowMactchMode: false,
            // },
            // {
            //     header: 'End date',
            //     field: 'countMC',
            //     filterTemplate: 'MultiSelect',
            //     ShowMactchMode: false,
            // },
            {
                header: "Status",
                // field: "status",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "bluecolor",
                slot: "status",
                fieldDisplay: "false",
                sortable: false,
            },
            {
                field: "action",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                fieldDisplay: "false",
                class: "filterdisplaynone last-column-position",
            },
        ];

        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            Code: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TemplateInfo: { value: null, matchMode: FilterMatchMode.IN, options: items },
        };

        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });
        const globalFilterFields = ref(headers.map((col) => col.field));

        const itemListed = ref([
            {
                items: [
                    {
                        label: "Edit",
                        icon: "editicon pi pi-pencil",
                        visible: InActivevisible,
                        command: async () => {
                            // amendment();
                            IsConfirmEdit(datas.value);
                        },
                    },
                    {
                        label: "Delete",
                        icon: "deleteicon pi pi-trash",
                        visible: true,
                        command: async () => {
                            // amendment();
                            IsConfirmDel(datas.value, 0);
                        },
                    },

                    {
                        label: "Active",
                        icon: "editicon pi pi-check-circle",
                        visible: Activevisible,
                        command: async () => {
                            // amendment();
                            IsConfirmDel(datas.value, 1);
                        },
                    },
                    {
                        label: "InActive",
                        icon: "deleteicon pi pi-minus-circle",
                        visible: InActivevisible,
                        command: async () => {
                            // amendment();
                            IsConfirmDel(datas.value, 2);
                        },
                    },
                ],
            },
        ]);

        //Functions
        const rowFocus = ref(false);

        async function FunctionRights() {
            debugger;
            const response = await MastersService.CheckMenuRights(
                EntityData.EntityId,
                rolesData.RoleId
            );
            console.log(response["result"]);

            for (let i = 0; i < response["result"].length; i++) {
                const operation = response["result"][i];
                if (operation.OperationName === "Create") {
                    ObjOperationId.value.CreateId = operation.OperationID;
                    Rights.value.Create = operation.IsActive;
                } else if (operation.OperationName === "Update") {
                    ObjOperationId.value.UpdateId = operation.OperationID;
                    Rights.value.Update = operation.IsActive;
                } else if (operation.OperationName === "Read") {
                    ObjOperationId.value.ReadId = operation.OperationID;
                    Rights.value.Read = operation.IsActive;
                } else if (operation.OperationName === "Delete") {
                    ObjOperationId.value.DeleteId = operation.OperationID;
                    Rights.value.Delete = operation.IsActive;
                }
            }
        }

        function RowClick(event: any) {
            rowFocus.value = true;

            router.push({
                path: "/campaignDetails",
                query: { Id: event.data.Id },
            });
        }

        const IsAdd = () => {

            debugger;
            campaigntype.value = true

        }

        const IsAddCampaign = (data) => {
            debugger;
            let permissionResult: any = checkPermission(Rights, "Add");
            if (permissionResult.hasPermission) {
                router.push({
                    path: "campaignCreation",
                    query: {
                        Type: data,
                        EntOp: 1027,
                    },
                });
            } else {
                toast.add(permissionResult.toast);
                return;
            }

        }

        const IsShow = async () => {
            loading.value = true
            const response = await campaignService.List();
            console.log(response['result']);
            let count = 0;

            response['result'] = response['result'].filter((item) => item.ClientId == usersData.OrganizationId && item.IsDeleted == false).map((item) => {
                item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
                count = count + 1;
                item.RowNumber = count;
                item.CampaignDate = moment(item.CampaignDate).format(
                    "DD-MM-YYYY"
                );
                return item;
            });

            items.value = response['result']
            loading.value = false

        }

        function toggle(event, data) {
            debugger;
            console.log(event);
            if (data.IsActive == 1) {
                InActivevisible.value = true;
                Activevisible.value = false;
            } else {
                InActivevisible.value = false;
                Activevisible.value = true;
            }

            datas.value = data;
            // Id.value = event.Id
            menu.value.toggle(event);
        }

        function IsConfirmEdit(data) {
            debugger;

            let permissionResult: any = checkPermission(Rights, "Edit");
            if (permissionResult.hasPermission) {
                dataEdit.value = data;
                Editmodel.value = true;
            } else {
                toast.add(permissionResult.toast);
                return;
            }
        }
        function IsConfirmDel(data, Status) {
            debugger;

            let permissionResult: any = checkPermission(Rights, "Delete");
            if (permissionResult.hasPermission) {
                data.ActiveStatus = Status;
                dataEdit.value = data;
                Editmodel.value = false;
                if (Status == 1) {
                    contentdel.value = t('confirmation.activecontent');
                } else if (Status == 2) {
                    contentdel.value = t('confirmation.inactivecontent');
                } else {
                    contentdel.value = t('confirmation.deletecontent');
                }
                Deletemodel.value = true;
            } else {
                toast.add(permissionResult.toast);
                return;
            }
        }

        //Edit Box
        function IsEdit(data) {
            debugger;
            editItems.value = data;
            Editmodel.value = false;
            router.push({
                path: "campaignCreation",
                query: {
                    Type: data.CampaignDate ? 1 : 2,
                    Id: data.Id
                },
            });
        }
        //Delete Box
        async function IsDelete(data) {
            loading.value = true;
            debugger;
            try {
                let result: any = "";
                if (data.ActiveStatus == 0) {
                    result = await campaignService.DeleteById(data.Id);
                } else {
                    let status = data.ActiveStatus == 1 ? true : false;
                    result = await campaignService.active(data.Id, status);
                }
                // const result = await CommonService.deleteBox(data.Id, data.ActiveStatus);
                let message = result["ErrorInfo"].ErrorCode;
                if (message == null) {
                    if (data.ActiveStatus == 1) {
                        pop.value.activatepop = true;
                    } else if (data.ActiveStatus == 2) {
                        pop.value.inactivepop = true;
                    } else {
                        deletepop.value = true;
                    }
                    Deletemodel.value = false;
                    loading.value = false;
                    rowFocus.value = false;
                    IsShow();
                }
            } catch (error) {
                loading.value = false;
            }
        }

        // Popup-Close
        function closetrigger() {
            deletepop.value = false;
            pop.value.activatepop = false;
            pop.value.inactivepop = false;
        }

        return {
            items,
            loading1,
            filteredColumns,
            globalFilterFields,
            headers,
            filters,
            IsAdd,
            RowClick,
            loading,
            campaigntype,
            IsAddCampaign,
            itemListed,
            Deletemodel,
            pop,
            closetrigger,
            IsConfirmEdit,
            IsConfirmDel,
            Editmodel,
            IsEdit,
            dataEdit,
            deletepop,
            toggle,
            contentdel,
            IsDelete,
            menu,
        }
    }

})
</script>

<style lang="scss" scoped>
.campaignpopupcontent {
    color: #999999;
    height: 110px;
    font-size: 14px;
    margin: 10px 0;
}
</style>